import { useEffect } from 'react';
import { loginWithTelegramWidget } from "../auth/tg-login";

/** Кнопка Telegram Login (через Edge Function tg-login) */
export default function TelegramLoginButton({ onSuccess }) {
  useEffect(() => {
    // виджет телеграма вызовет это колбэком
    // @ts-ignore
    window.onTelegramAuth = async (user) => {
      try {
        await loginWithTelegramWidget(user);
        // Если передан callback, вызываем его
        if (onSuccess) {
          onSuccess();
        }
      } catch (e) {
        alert(e.message);
      }
    };

    // Альтернативный способ загрузки виджета
    const loadTelegramWidget = () => {
      const container = document.getElementById('telegram-login-container');
      if (!container) return;

      // Очищаем контейнер
      container.innerHTML = '';

      // Создаем скрипт
      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-widget.js?22';
      script.async = true;
      script.setAttribute('data-telegram-login', (process.env.REACT_APP_TG_BOT_NAME || "").replace("@", ""));
      script.setAttribute('data-size', 'large');
      script.setAttribute('data-userpic', 'false');
      script.setAttribute('data-request-access', 'write');
      script.setAttribute('data-onauth', 'onTelegramAuth(user)');

      // Добавляем скрипт в контейнер
      container.appendChild(script);
    };

    // Загружаем виджет после небольшой задержки
    setTimeout(loadTelegramWidget, 100);

    return () => {
      const container = document.getElementById('telegram-login-container');
      if (container) {
        container.innerHTML = '';
      }
    };
  }, [onSuccess]);

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <div id="telegram-login-container">
        {/* Виджет будет загружен сюда */}
      </div>
    </div>
  );
}
